import {Field} from "@builtbypixel/nucleus";
import {Box} from "@chakra-ui/react";

const CruiseLeg = ({ name, searchTags, shipOptions }) => {
    return (
        <>
            <Field
                auto
                isFullWidth
                component="select"
                name={`search_tags`}
                label="Search Tags"
                options={searchTags}
                labelKey="value"
                valueKey="id"
                isMulti
                isHorizontal
            />

            <Box display='flex' flexDir='row' gridGap='3'>
                <Field
                    auto
                    isFullWidth
                    component="select"
                    name={`${name}.leg_detail.ship`}
                    label="Ship"
                    options={shipOptions}
                    labelKey="name"
                    valueKey="id"
                />
            </Box>

            <Box display='flex' flexDir='row' gridGap='3'>
                <Field
                    auto
                    isFullWidth
                    component="select"
                    name={`${name}.leg_detail.tags`}
                    label="Destination Tags"
                    options={shipOptions}
                    labelKey="value"
                    valueKey="id"
                    isMulti
                    isHorizontal
                />

                <Field
                    auto
                    isFullWidth
                    component="text"
                    name={`${name}.leg_detail.day_from_to`}
                    label="Day From - To"
                />
            </Box>

            <Field
                auto
                isFullWidth
                component="richtext"
                name={`${name}.leg_detail.summary`}
                label="Summary"
            />

            <Field
                auto
                isFullWidth
                component="file"
                name={`${name}.leg_detail.images`}
                label="Images"
            />

            <Field
                auto
                isFullWidth
                component="repeater"
                name={`${name}.guide`}
                label="Itinerary"
                fieldArray={[{
                    name: "title",
                    component: "text",
                    label: "Title"
                },{
                    name: "day_from_to",
                    component: "text",
                    label: "Day From - To"
                }]}
                singleName="Item"
            />
        </>
    )
};

export default CruiseLeg;